module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAGJJREFUSA1jTE1N9WRgYJgFxDJATE3wBGhYGhOQoIXhIIeCHDwLZAG1XQ4yHAZkQBbQFIxaQDB4R4NoNIgIhgBBBaOpaDSICIYAQQWjqYioIALV/rQCT0BxkAbEtLAE3GwBAE4vCagkGpybAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/radio-default.png
// module id = wYxF
// module chunks = 1